import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { SummaryConfig } from '@repo/sdk/models/components';

import { equipmentBrowserResponseAtom } from './equipment-browser-response.state';

/**
 * The equipment browser summaries by ids atom.
 * Allows the caller to fetch a set of SummaryConfig by device ID.
 */
export const equipmentBrowserSummariesByIdsAtom = atomFamily(
  (deviceIds: string[]) =>
    atom<SummaryConfig[]>((get) => {
      const equipment = get(equipmentBrowserResponseAtom);

      return (
        equipment?.summaryConfigs.filter((summary) => deviceIds.includes(summary.referenceId)) ?? []
      );
    }),
  (a: string[], b: string[]) => a.every((id, index) => id === b[index])
);
